import { observer } from 'mobx-react';
import React from 'react';
import { Card, CardContent, ITagProps, Separator } from 'telia-front-react';
import { TranslationsContext } from '@teliaee/telia-translate';
import { Package } from '../MobileBusinessInterfaces';
import PackageCardContent from './PackageCardContent';
import PackageCardHeaderContent from './PackageCardHeaderContent';

interface MobileBusinessPackageCardProps {
  index: number;
  mobilePackage: Package;
}

const PackageCard = observer((props: MobileBusinessPackageCardProps): React.JSX.Element => {
  const { index, mobilePackage } = props;
  const { translate } = React.useContext(TranslationsContext);
  const isUnlimitedPlus = mobilePackage.isUnlimitedPlus;

  const mergedTagsTop = (): ITagProps[] | boolean => {
    const mergedTags: ITagProps[] = [];
    if (mobilePackage.isOffer) {
      mergedTags.push({
        text: translate('mobileBusiness.offerBadgeText'),
        purpose: 'campaign-3',
        size: 'tiny',
      });
    }
    if (mobilePackage.isUnlimitedPlus) {
      mergedTags.push({
        text: translate('mobileBusiness.premiumBadgeText'),
        purpose: 'recommended',
        size: 'tiny',
      });
    }
    if (mobilePackage.tagsTop) {
      mergedTags.push(...mobilePackage.tagsTop);
    }

    return mergedTags.length ? mergedTags : true;
  };

  return (
    <Card className="text-left" type={isUnlimitedPlus ? 'light' : undefined} background={isUnlimitedPlus ? 'transparent' : 'brand-secondary-bg-subtlest'}>
      <CardContent tagTop={mergedTagsTop()}>
        <PackageCardHeaderContent {...{ index, mobilePackage }} />
        <Separator spacing="small" color="invisible" />
        <PackageCardContent {...{ mobilePackage }} />
      </CardContent>
    </Card>
  );
});

export default PackageCard;
